/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Fragment, ReactNode } from "react";
// eslint-disable-next-line no-restricted-imports
import { Tooltip } from "react-tooltip";

/**
 * Value that should be specified for the `data-tooltip-id` attribute of cell
 * renderer tooltip anchors
 */
export const DATA_TABLE_TOOLTIP_ID = "DATA_TABLE_TOOLTIP_ID";

const styles = {
  tooltip: css`
    z-index: 9000;
    max-width: 400px;
  `,
};

interface DataTableTooltipProviderProps {
  children: ReactNode;
}

/**
 * Wrapper component that renders a tooltip shared by all cell renderers in a
 * data table or analysis table
 */
export const DataTableTooltipProvider = ({
  children,
}: DataTableTooltipProviderProps) => {
  return (
    <Fragment>
      <Tooltip id={DATA_TABLE_TOOLTIP_ID} css={styles.tooltip} />
      {children}
    </Fragment>
  );
};
